<div id="tree-container">
    <mat-toolbar *ngIf="emptyNode">
        <mat-toolbar-row *ngVar="isValidFolder(emptyNode) as validFolder"
            (click)="validFolder ? folderClick(emptyNode) : false"
            [ngClass]="[selectedFolder && selectedFolder.mediaFolderId == emptyNode.mediaFolderId ? 'selected-folder': '', validFolder ? 'valid-folder' : 'invalid-folder']">
            <mat-icon class="tree-folder-icon"
                [color]="validFolder && (!selectedFolder || selectedFolder.mediaFolderId != emptyNode.mediaFolderId) ? 'primary' : ''">
                account_tree
            </mat-icon>
            <span>{{emptyNode.name}}</span>
        </mat-toolbar-row>
    </mat-toolbar>
    <mat-tree id="tree" [dataSource]="dataSource" [treeControl]="treeControl">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
            <div *ngVar="isValidFolder(node) as validFolder" class="folder-container"
                (click)="validFolder ? folderClick(node) : false"
                [ngClass]="[selectedFolder && selectedFolder.mediaFolderId == node.mediaFolderId ? 'selected-folder': '', validFolder ? 'valid-folder' : 'invalid-folder']">
                <button mat-icon-button disabled></button>
                <mat-icon
                    [color]="validFolder && (!selectedFolder || selectedFolder.mediaFolderId != node.mediaFolderId) ? 'primary' : ''"
                    class="tree-folder-icon">folder</mat-icon>
                <div class="tree-folder-name">{{ node.getName(utils.getLanguage()) }}</div>
            </div>
        </mat-tree-node>
        <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
            <div *ngVar="isValidFolder(node) as validFolder" class="folder-container"
                (click)="validFolder ? folderClick(node) : false"
                [ngClass]="[selectedFolder && selectedFolder.mediaFolderId == node.mediaFolderId ? 'selected-folder': '', validFolder ? 'valid-folder' : 'invalid-folder']">
                <button mat-icon-button [attr.aria-label]="'toggle ' + node.filename" matTreeNodeToggle>
                    <mat-icon class="tree-folder-icon">
                        {{treeControl.isExpanded(node) ? 'remove' : 'add'}}
                    </mat-icon>
                </button>
                <mat-spinner color="primary" class="tree-folder-icon" *ngIf="node.isLoading" [diameter]="20">
                </mat-spinner>
                <mat-icon
                    [color]="validFolder && (!selectedFolder || selectedFolder.mediaFolderId != node.mediaFolderId) ? 'primary' : ''"
                    class="tree-folder-icon" *ngIf="!node.isLoading">folder</mat-icon>
                <div class="tree-folder-name">{{ node.getName(utils.getLanguage()) }}</div>
            </div>
        </mat-tree-node>
    </mat-tree>
</div>